import { render } from "./ComplianceDashboard.vue?vue&type=template&id=d79fa70a&scoped=true"
import script from "./ComplianceDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceDashboard.vue?vue&type=script&lang=js"

import "./ComplianceDashboard.vue?vue&type=style&index=0&id=d79fa70a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79fa70a"]])

export default __exports__